// import pickBy from 'lodash/pickBy'

export function saveFile(file: Blob | string, filename?: string) {
  let url = file
  if (typeof file !== 'string') {
    url = window.URL.createObjectURL(new Blob([file]))
  }
  const link = document.createElement('a')
  if (typeof url === 'string') {
    link.href = url
  }
  if (filename) {
    link.setAttribute('download', filename)
  }
  document.body.appendChild(link)
  link.click()
}

export function hasOwnPropertyCall(obj: Object, key: string) {
  if (!obj) return false
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export function getByKey(
  obj: Record<string, any>,
  key: string | null | undefined,
  defaultValue: any = null,
) {
  if (key == null || !hasOwnPropertyCall(obj, key)) return defaultValue
  return obj[key]
}

export function elementPosition(elem: HTMLElement) {
  if (!elem) return null
  const rect = elem.getBoundingClientRect()
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export function elementPositionById(id: string) {
  const elem = document.getElementById(id)
  if (!elem) return null
  return elementPosition(elem)
}

export function getAbsoluteUrl(path: string) {
  return `${window.location.origin}${path}`
}

export function autoImplement<T>(defaults?: Partial<T>) {
  return class {
    constructor() {
      Object.assign(this, defaults || {})
    }
  } as new () => T
}

export function openPopupWindow({
  url = 'about:blank',
  windowParent,
  target,
  width,
  height,
}: {
  width: number
  height: number
  url?: string
  target?: string
  windowParent?: Window
}): Window | null {
  const win = windowParent ?? window
  let x = 0
  let y = 0
  if (win.top) {
    y = win.top.outerHeight / 2 + win.top.screenY - height / 2
    x = win.top.outerWidth / 2 + win.top.screenX - width / 2
  }
  return win.open(
    url,
    target,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${width}, height=${height}, top=${y}, left=${x}`,
  )
}

// export const removeUndefinedProps = <T extends object>(originalObject: T): Partial<T> =>
//   pickBy(originalObject, v => v !== undefined)

export const joinStrings = (arr: (string | number | undefined | null)[], separator = ' ') =>
  arr.filter(str => str && str?.toString().length > 0).join(separator)
